<template>
<div class="chapter">
<div class="inner_page">
<p class="sp" id="ack"> </p>
<p class="FMH-1"><span href="#/xhtml/contents#c_ack" title="Link target outside of Sample"><span class="ePub-B">Acknowledgments</span></span></p>
<p class="FMTNI">Thanks to all those at St. Martin’s Press who have made this book possible, including Michael Homler and Lauren Jablonski. Thanks also to the many people who have helped me muse over the relationship of mathematics and science, notably Professor Adrian Moore of Oxford University, who was inspired to go into philosophy by the same math teacher who spurred me on to take an interest in mathematics and infinity, Neil Sheldon of the Manchester Grammar School.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// acknowledgments.vue?36ed4860